import { render, staticRenderFns } from "./PatientDashboardPage.vue?vue&type=template&id=9f1601b8&scoped=true"
import script from "./PatientDashboardPage.vue?vue&type=script&lang=ts"
export * from "./PatientDashboardPage.vue?vue&type=script&lang=ts"
import style0 from "./PatientDashboardPage.vue?vue&type=style&index=0&id=9f1601b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1601b8",
  null
  
)

export default component.exports